import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteCancelOfferingTransaction } from '@arrived/api_v2';
import { OfferingTransaction, OfferingTransactionId } from '@arrived/models';

import { balanceKeyFn, offeringBalancesKeyFn } from '../accounts';
import { offeringKeyFn, offeringsKeyFn } from '../offerings';
import { UseMutationOptions } from '../queries.utils';
import { offeringSharesAvailableKeyFn } from '../sharesAvailable';
import { accountTradesQueryKeyFn, tradeQueryKeyFn, userTradesQueryKeyFn } from './trades.keys';

export function useDeleteTradeMutation(options?: UseMutationOptions<OfferingTransaction, OfferingTransactionId>) {
  const queryClient = useQueryClient();

  return useMutation((tradeId) => deleteCancelOfferingTransaction(tradeId), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: tradeId, accountId, userId, offeringId } = data;

      queryClient.invalidateQueries(offeringSharesAvailableKeyFn(offeringId));
      queryClient.invalidateQueries(offeringsKeyFn());
      queryClient.invalidateQueries(offeringKeyFn(offeringId));

      queryClient.invalidateQueries(balanceKeyFn(accountId));
      queryClient.invalidateQueries(offeringBalancesKeyFn(accountId));

      queryClient.invalidateQueries(tradeQueryKeyFn(tradeId));
      queryClient.invalidateQueries(userTradesQueryKeyFn(userId));
      queryClient.invalidateQueries(accountTradesQueryKeyFn(accountId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
